export const safeGetUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    return null;
  }
};

// ---- HELPERS ---------------------------------------------------------------
export const normalizePaged = (raw, fallback = {}) => {
  // Try common envelopes: result.items, result.data, or raw arrays
  const result = raw?.result ?? raw;
  const items =
    result?.items ??
    result?.data ??
    (Array.isArray(result) ? result : []) ??
    [];

  const pageNumber =
    result?.pageNumber ??
    result?.currentPage ??
    fallback.pageNumber ??
    1;

  const pageSize =
    result?.pageSize ??
    fallback.pageSize ??
    (Array.isArray(items) ? items.length || 10 : 10);

  const totalCount = result?.totalCount ?? result?.count ?? null;
  const totalPages =
    result?.totalPages ??
    (typeof totalCount === "number" ? Math.ceil(totalCount / pageSize) : null);

  const hasNext =
    typeof result?.hasNext === "boolean"
      ? result.hasNext
      : (typeof totalPages === "number"
          ? pageNumber < totalPages
          : items.length >= pageSize);

  const hasPrevious =
    typeof result?.hasPrevious === "boolean"
      ? result.hasPrevious
      : pageNumber > 1;

  return { items, pageNumber, pageSize, totalCount, totalPages, hasNext, hasPrevious };
};